import _ from 'lodash'
import { FormPlugin } from '@wix/forms-common'

export const getActivePlugin = (plugins: FormPlugin[]): FormPlugin => {
  return _.first(plugins) || FormPlugin.FORM_BUILDER
}

export const getPlugins = (componentConnection: ComponentConnection): ComponentPlugin[] =>
  _.get(componentConnection, 'config.plugins', [])

export const convertPluginsToFormsPlugins = (plugins: ComponentPlugin[] = []): FormPlugin[] =>
  _.map(plugins, 'id')

export const findPlugin = (plugins: ComponentPlugin[], pluginId: FormPlugin) =>
  _.find(plugins, plugin => plugin.id === pluginId)

export const isNativeForm = (plugins: ComponentPlugin[]) =>
  _.size(plugins) === 0 || (_.size(plugins) === 1 && !!findPlugin(plugins, FormPlugin.FORM_BUILDER))

export const updatePlugin = (plugins: ComponentPlugin[], newPlugin: ComponentPlugin) => {
  const updatedPlugins = _.filter(plugins, plugin => plugin.id !== newPlugin.id)
  return [...updatedPlugins, newPlugin]
}

export const removePlugin = (plugins: ComponentPlugin[], pluginId: FormPlugin) => {
  return _.filter(plugins, plugin => plugin.id !== pluginId)
}

export const getActivePluginFromComponentConnection = (
  componentConnection: ComponentConnection,
): FormPlugin => getActivePlugin(convertPluginsToFormsPlugins(getPlugins(componentConnection)))

export const getFormPlugins = (componentConnection: ComponentConnection) =>
  convertPluginsToFormsPlugins(getPlugins(componentConnection))

export const isMultiStepPlugin = (plugins: FormPlugin[]) =>
  _.includes(plugins, FormPlugin.MULTI_STEP_FORM)
export const isRegistrationFormPlugin = (plugins: FormPlugin[]) =>
  _.includes(plugins, FormPlugin.REGISTRATION_FORM)
